import {FinancingPurpose} from '../../_types/selectOptionsTypes/OverviewTypes';

export const financingPurposeOptions: Array<FinancingPurpose> = [
  {value: 'ACQUISITION', label: 'Acquisition'},
  {value: 'NEW_DEVELOPMENT', label: 'New development'},
  {value: 'REDEVELOPMENT', label: 'Redevelopment'},
  {value: 'REFINANCE', label: 'Refinance'},
];
